import { useState } from "react";
import { useParams } from "react-router-dom";

//Icons
import { MdEdit } from "react-icons/md";

//Bootstrap
import { Row, Col } from "react-bootstrap";

//UI components
import Field from "../../../ui/Field";

//utils
import currencyFormatToEUR from "../../../utils/currencyFormatToEUR";

//Components
import NacrtovanaVrednostProjektaEditFrom from "./NacrtovanaVrednostProjektaEditForm";

//API calls
import { useGetNacrtovaneVrednostiProjekta } from "../../../../services/ProjectDetails/financeAPI";
import tooltipsText from "../../../utils/tooltipsText";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const FinanceSkupniPodatkiNacrtovano = () => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const { project } = useProjectDetailsContext();

  const { data: nacrtovaneVrednosti, isLoading } =
    useGetNacrtovaneVrednostiProjekta(id);

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">Celoten projekt</h6>
        <p>Nalaganje...</p>
      </div>
    );
  }

  // Format lastno sofinanciranje to include both the value and the percentage in parentheses
  const lastnoSofinanciranjeInDelez = `${currencyFormatToEUR(
    nacrtovaneVrednosti?.nacrtovanaLastnaVrednost,
    true,
  )} (${nacrtovaneVrednosti?.nacrtovanaDelez ? `${nacrtovaneVrednosti.nacrtovanaDelez}%` : "Ni podatka o deležu"})`;

  return (
    <Row>
      <Col md={5}>
        <h6 className="form-section-heading">Celoten projekt</h6>
        {!isEditing && (
          <>
            <Field
              label="Vrednost projekta"
              value={currencyFormatToEUR(
                nacrtovaneVrednosti?.nacrtovanaVrednost,
              )}
              tooltip={tooltipsText.P41vrednostProjekta}
            />

            <Field
              label="Sofinanciranje iz projektnega vira"
              value={currencyFormatToEUR(
                nacrtovaneVrednosti?.nacrtovaniProjektniViri,
              )}
              tooltip={tooltipsText.P41vrednostSofinanciranjaIzProjektnihVirov}
            />
          </>
        )}
        {isEditing && (
          <NacrtovanaVrednostProjektaEditFrom
            setIsEditing={setIsEditing}
            nacrtovaneVrednosti={nacrtovaneVrednosti}
          />
        )}
      </Col>
      <Col md={5}>
        <h6 className="form-section-heading">Podatki ki se nanašajo na UM</h6>
        <Field
          label="Vrednost projekta"
          value={currencyFormatToEUR(
            nacrtovaneVrednosti?.nacrtovanaVrednostUM,
            true,
          )}
          tooltip={tooltipsText.P41vrednostProjektaZaUM}
        />
        <Field
          label="Lastno sofinanciranje"
          value={lastnoSofinanciranjeInDelez}
          tooltip={tooltipsText.P41VrednostDelezLastnegaSofinanciranjaUM}
        />
        <Field
          label="Sofinanciranje iz projektnega vira"
          value={currencyFormatToEUR(
            nacrtovaneVrednosti?.nacrtovanaVrednostViri,
            true,
          )}
          tooltip={tooltipsText.P41vrednostSofinanciranjaIzProjektnihVirovZaUM}
        />
        <Field
          label="Obseg zaposlitev (izraženo v FTE)"
          value={
            nacrtovaneVrednosti?.nacrtovaniObseg
              ? `${nacrtovaneVrednosti.nacrtovaniObseg}`
              : "Nepopolni podatki"
          }
          tooltip={tooltipsText.P41obsegZaposlitveFTE}
        />
      </Col>
      <Col md={2} className="d-flex justify-content-md-end align-items-start ">
        {!isEditing && (
          <RoleGuard
            moduleKey={MODULES.PROJEKTI}
            roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
            vodilnaClanicaProjektaID={project?.clanicaID}
          >
            <button
              type="button"
              className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
              onClick={() => setIsEditing(true)}
            >
              <span className="d-flex align-items-center gap-1">
                Uredi <MdEdit />
              </span>
            </button>
          </RoleGuard>
        )}
      </Col>
    </Row>
  );
};

export default FinanceSkupniPodatkiNacrtovano;
